import React from "react";

import { templates } from "@reactivated";

import {
    firstBlockOverlapsNav,
    isOverlapBlockType,
} from "../components/HeaderNav/overlap";
import { PageSkeleton } from "../components/PageSkeleton";
import { RecipePageBody } from "../components/RecipePageBody";

export const Template = (props: templates.RecipePageTemplate) => (
    <PageSkeleton
        {...props.page}
        overlapNav={firstBlockOverlapsNav(
            props.page.body.value.slice(0, 1).find(isOverlapBlockType),
        )}
    >
        <RecipePageBody
            title={props.page.title}
            hero={props.page.hero?.block || null}
            body={props.page.body.value}
        />
    </PageSkeleton>
);
